<template>
  <fn-panel class="panel--image">
    <fn-grid>
      <fn-grid-item
        :columns="12"
        :columns-m="columnSize"
      >
        <div
          v-if="imagePositionRight"
          class="p-content"
        >
          <slot name="default" />
        </div>
        <div
          v-else
          class="p-figure"
          :class="{
            'show-m': imageHideMobile,
          }"
        >
          <slot name="image" />
        </div>
      </fn-grid-item>
      <fn-grid-item
        :columns="12"
        :columns-m="columnSizeRight"
      >
        <div
          v-if="imagePositionRight"
          class="p-figure"
          :class="{
            'show-m': imageHideMobile,
          }"
        >
          <slot name="image" />
        </div>
        <div
          v-else
          class="p-content"
        >
          <slot name="default" />
        </div>
      </fn-grid-item>
    </fn-grid>
  </fn-panel>
</template>

<script>
export default {
  props: {
    columnSize: {
      type: String,
      default: '6',
    },
    imagePositionRight: {
      type: Boolean,
    },
    imageHideMobile: {
      type: Boolean,
    },
  },
  computed: {
    columnSizeRight() {
      switch (this.columnSize) {
        case '3':
          return '9';
        case '4':
          return '8';
        case '5':
          return '7';
        case '6':
          return '6';
        case '7':
          return '5';
        case '8':
          return '4';
        case '9':
          return '3';
        default:
          return '6';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  overflow: hidden;

  .p-figure {
    position: relative;

    :deep(img),
    :deep(picture) {
      display: block;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100px;
      background: $color-general-background-neutral-default;
      background: linear-gradient(
        0deg,
        rgba($color-general-background-neutral-default, 0.95) 0%,
        rgba($color-general-background-neutral-default, 0) 100%
      );

      @include bp(m) {
        opacity: 0;
      }
    }
  }

  .p-content {
    padding: $pad;
    height: 100%;

    @include bp(m) {
      padding: $pad * 2;
    }
  }

  .grid {
    margin-bottom: 0;
  }

  .grid-item {
    &:not(:last-child) {
      margin-bottom: 0;
    }
    @include bp(m) {
      margin-bottom: 0;
    }
  }

  &.panel--image {
    padding: 0;
  }

  &.panel--error {
    .p-content {
      display: flex;
    }
  }
}
</style>
